import { Flex, Image, Text } from '@chakra-ui/react'

const Footer = ({showNavigate}) => {
  return (
    <Flex
      alignItems='center'
      px='20px' 
      bg='#F8FAFC' 
      h='48px'
      w='full' 
      borderBottomLeftRadius='20px' 
      borderBottomRightRadius='20px'
      flexShrink={0}
    >
      {showNavigate && (
        <>
          <Image mr='10px' src='/assets/icons/navigateIcon.svg' />
          <Text
            color='#898A93'
            fontWeight='700'
            fontSize='12px'
            lineHeight='16px'
            letterSpacing='0.08em'
          >
            Navigate
          </Text>
        </>
      )}
    </Flex>
  )
}

export default Footer